import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CardInfo from "./CardInfo";
import get from "lodash/get";
import { isExternalStory } from "../../../utils/story";

import "../three-col-six-stories.m.css";

const StoryCard = ({ story, showTimeStamp, showReadTime, showSeparator, sectionSlug }) => {
  const heroImage = get(story, ["hero-image-s3-key"], "");
  const storyAlternateData = get(story, ["alternative", "home", "default"], {});
  const alternateHeroImage = get(storyAlternateData, ["hero-image", "hero-image-s3-key"], "");
  const imageShown = heroImage || alternateHeroImage;

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target} styleName={`${showSeparator ? "" : "no-separator"}`}>
      <div styleName={`horizontal-card ${imageShown ? "" : "no-image"} ${showSeparator ? "" : "no-separator"}`}>
        <div styleName="info">
          <CardInfo story={story} sectionSlug={sectionSlug} />
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
        </div>
        {imageShown && (
          <div>
            <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
          </div>
        )}
      </div>
    </Link>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showSeparator: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryCard;
